export const FaqData = {
  // title: "FAQ (How it works)",

  rows: [
    {
      title: "How much will I make once I start tuitions?",
      content: `You can earn anywhere between Rs. 4,000 to Rs. 40,000 per month per tuition, depending on the subjects you teach and the number of tuition opportunities you take from us`,
    },
    {
      title: "How many tuitions I can take? Is there any limit in taking tuitions? ",
      content:
        "You can take as many tuitions as you like. It all depends on your availability and you timings.  There is no limit from HomeShiksha side in providing you tuitions opportunities. ",
    },
    {
      title: "What is the difference between verified tutor and unverified tutor? ",
      content: `Unverified Tutor: After submitting your basic details through the registration form, your profile remains unverified. HomeShiksha don't give any tuition opportunities to unverified tutor. Only verified tutor are eligible to grab opportunity and earn with us.
       <br>
        Verified Tutor: To become a verified tutor, a tutor must submit or upload their valid Government ID proof and pay the verification fee by choosing a subscription plan and then they can choose the tuition as per their comfort and start earning with us.`,
    },
    {
      title: "Can I pay the verification fee after I receive a requirement?  ",
      content: `Unfortunately, it's not possible as you are supposed to visit students home representing 
        HomeShiksha. Therefore, before proceeding, we need to ensure that the tutor is verified by 
        HomeShiksha.  `,
    },
    {
      title: "What is the policy between HomeShiksha and tutors? ",
      content: `For every new tuition confirmation, HomeShiksha will charge you an upfront of only 50% of the tuition fees as a commission upon student/parent's confirmation. Starting from the second month, 90% of the tuition fee will be disbursed to the tutor via the HomeShiksha platform. Failure to comply with these policies will result in the removal of the tutor from all platform benefits and potential blocking from the HomeShiksha platform.\nFor Online Tuitions HomeShiksha will charge you an upfront of 1 month tuition fees as a commission upon student/parent's confirmation. Starting from the second month, 90% of the tuition fee will be disbursed to the tutor via the HomeShiksha platform. `,
    },
    {
      title: "Does HomeShiksha provide online tuition or home tuition? ",
      content: `HomeShiksha exclusively offers home tuition, where tutors are required to go to the students 
        houses to teach. `,
    },
    {
      title: "After how much time, I will get tuition opportunity once I become a verified tutor?",
      content: `We get day to day tuition requirements on daily basis. You can grab any tuition opportunity 
        as per you subjects you can teach, timing and distance.  You can also grab spot tuition offers 
        which matches your profile.`,
    },
    {
      title: " Can I obtain the requirements locally so that I don't have to travel anywhere?",
      content: `You are required to travel to a nearby location within a radius of 5 kilometres. We do our best 
        to provide you with the best tuition opportunity which suits your distance, timing, and your 
        flexibility. `,
    },
  ],
};
